import React, { Component } from "react";
import Fade from "react-reveal";
import emailjs from "@emailjs/browser";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";

class Contact extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      open: false,
      loading: 2,
      openDialog: false,
    };
  }

  sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  sendEmail = (e) => {
    this.setState({
      loading: 0,
    });
    this.setState({
      open: true,
    });
    e.preventDefault();

    emailjs
      .sendForm(
        "service_rauforg",
        "template_2fas96o",
        this.form.current,
        "JF-5rSuh1c219hUzS"
      )
      .then(
        (result) => {
          this.setState({
            loading: 1,
          });
          this.sleep(2000).then((r) => {
            this.setState({
              loading: 2,
            });
          });
          // <Snackbar open={this.state.open} autoHideDuration={6000} message="Email gesendet" />
        },
        (error) => {
          console.log(error.text);
          this.setState({
            loading: 3,
          });
          this.sleep(4000).then((r) => {
            this.setState({
              loading: 2,
            });
          });
        }
      );
  };

  handleClick = () => {
    this.setState({
      open: true,
    });
  };

  handleDialogOpen = () => {
    this.setState({
      openDialog: true,
    });
  };

  handleDialogClose = () => {
    this.setState({
      openDialog: false,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleClickLoading = () => {
    this.setState({
      loading: !this.state.loading,
    });
  };

  render() {
    if (!this.props.data) return null;
    const message = this.props.data.contactmessage.toLowerCase();

    return (
      <section id="contact">
        <Fade duration={600}>
          <div className="row section-head">
            <div className="three columns header-col">
              <h1>
                <span>nachricht</span>
              </h1>
            </div>
            <div className="nine columns">
              <p className="lead">
                <span>{message}</span>
              </p>
            </div>
          </div>
        </Fade>
            <div className="row">
              <Fade duration={600} delay={100}>
                <div className="eight columns">
                  <form ref={this.form} onSubmit={this.sendEmail}>
                    <label>name</label>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="name"
                      name="from_name"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& > fieldset": {
                            border: "none",
                          },
                        },
                      }}
                    />
                    <label>email</label>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      name="from_email"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& > fieldset": {
                            border: "none",
                          },
                        },
                      }}
                    />
                    <label>nachricht</label>
                    <TextField
                      margin="normal"
                      required
                      id="message"
                      name="message"
                      multiline
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& > fieldset": {
                            border: "none",
                          },
                        },
                      }}
                      // style={{width: '400px'}}
                    />
                    {this.state.loading === 0 ? (
                      <div className="form-status">
                        <CircularProgress />
                      </div>
                    ) : this.state.loading === 1 ? (
                      <div className="form-status">
                        <Alert
                          variant="filled"
                          severity="success"
                          style={{
                            background: "var(--color-accent)",
                            color: "var(--color-primary)",
                          }}
                        >
                          <AlertTitle style={{ fontSize: "15px" }}>
                            Nachricht gesendet
                          </AlertTitle>
                        </Alert>
                      </div>
                    ) : this.state.loading === 3 ? (
                      <div className="form-status">
                        <Alert variant="filled" severity="error">
                          <AlertTitle style={{ fontSize: "15px" }}>
                            Senden fehlgeschlagen — bitte erneut versuchen oder
                            direkt an mail@bob.salon schreiben.
                          </AlertTitle>
                        </Alert>
                      </div>
                    ) : (
                      <div>
                        <button className="submit" type="submit">
                          Senden
                        </button>
                        <p className="form-privacy">
                          Mit dem Absenden verarbeiten wir Ihre Angaben, um Ihre
                          Anfrage zu beantworten. Näheres in der{" "}
                          <a href="./datenschutz.html">Datenschutzerklärung</a>.
                        </p>
                      </div>
                    )}
                  </form>
                </div>
              </Fade>
            </div>
      </section>
    );
  }
}

export default Contact;
